import { sendToMeasurementsWithParams } from "@app/routes/vocabulary/api/index";
import {
  getBoardStateById, setWordStateById,
  setLastReadingWord, setFirstReadingWord,
  setStartRecording, setEndRecording,
  setMeasurementUUID, setMeasurementWCPM_UUID,
  updateStudentReadingStatus,
} from "@app/routes/activities/reading/store/readingSlice";
import { h5pGamesSelectStudentStatusById } from "@app/routes/treatmentV3/store/h5pGamesSlice";
import { selectTreatment } from "@app/routes/treatmentV3/store/treatmentServerDataSlice";
import { currentUser } from "@app/routes/auth/selectors";
import { ROLES } from "@app/constants";
import { MEASUREMENT_TYPES, MEASUREMENT_WCPM_TYPES } from "@amplio-common/measurements/constants";
import { PROBLEMS, ALL_MISTAKE_TYPES, ALL_DIFFICULTIE_TYPES } from "@app/routes/activities/reading/constants";
import { PREVIEW_BOARD_ID } from "@app/routes/treatmentV3/constants";

const studentActions = {
  //[setSelectedGame]: (store, boardId, state) => {
  //  trackGamesSelectEvent(state, { });
  //},
};

const sendWCPM = async (store, boardId, state) => {
  const { measurementUUID, measurementWCPM_UUID, wcpm } = state;

  if (measurementUUID && Number.isInteger(wcpm)) {
    const req = {
      uuid: measurementUUID,
      measurements: [{ uuid: measurementWCPM_UUID || undefined, count: wcpm }],
      measurement_type: MEASUREMENT_TYPES.WCPM,
      instant_create: !measurementWCPM_UUID ? 1 : undefined,
    };

    const { response } = await sendToMeasurementsWithParams(req);
    
    const WCPM_UUID = response?.measurements?.[0]?.uuid;
    !measurementWCPM_UUID && store.dispatch(setMeasurementWCPM_UUID({ boardId, value: WCPM_UUID }));
  }
};

const sendMeasurement = async (store, boardId, state, readingState, params) => {
  const { measurementUUID } = readingState;

  if (boardId === PREVIEW_BOARD_ID) {
    return;
  }
  store.dispatch(updateStudentReadingStatus({ id: boardId, changes: { isUpdatingMeasurements: true, isUpdatingMeasurementsError: false } }));

  if (!measurementUUID || measurementUUID === "none") {
    const treatment = selectTreatment(state);
    const h5pStudentData = h5pGamesSelectStudentStatusById(state, boardId);
    const h5pGame = h5pStudentData?.h5pGame;
    
    const req = {
      task: {
        student_id: boardId,
        therapist_id: treatment?.therapist,
        treatment_id: treatment?.id,
        task_type: h5pGame?.game?.title,
        extras: {
          type: MEASUREMENT_WCPM_TYPES.READING,
          story_id: h5pGame?.game?.id,
          story_text: h5pGame?.game?.text,
        },
        area: h5pGame?.area,
        filters: h5pGame?.filters,
        measurement_type: MEASUREMENT_TYPES.READING,
      },
    };

    const { response } = await sendToMeasurementsWithParams(req);
    const UUID = response.uuid;
    UUID && store.dispatch(setMeasurementUUID({ boardId, value: UUID }));

    if (params?.task?.uuid === "none") {
      params.task.uuid = UUID;
    }
    if (params?.uuid === "none") {
      params.uuid = UUID;
    }
  }
  try {
    await sendToMeasurementsWithParams(params);
    store.dispatch(updateStudentReadingStatus({ id: boardId, changes: { isUpdatingMeasurements: false, isUpdatingMeasurementsError: false } }));
  } catch (e) {
    store.dispatch(updateStudentReadingStatus({ id: boardId, changes: { isUpdatingMeasurements: false, isUpdatingMeasurementsError: true } }));
  }
};

const therapistActions = {
  [setWordStateById]: (store, boardId, state, readingState, value) => {
    const mistake = PROBLEMS?.[value.problemType];

    const isMistake = (mistake && ALL_MISTAKE_TYPES.includes(mistake.type));
    const isDifficulty = (mistake && ALL_DIFFICULTIE_TYPES.includes(mistake.type));

    const measurementWord = {
      client_id: readingState.measurementUUID + value.wordId,
      word: value.word,
      count_from_start: value.wordId,
      count_from_paragraph: value.indexInSentence,
      story_duration: (Date.now() - readingState.startRecording) / 1000,
      mistake_type: isMistake ? mistake.type : 0,
      difficulty_type: isDifficulty ? mistake.type : 0,
      hidden: !mistake ? 1 : undefined,
    };

    sendMeasurement(store, boardId, state, readingState, {
      uuid: readingState.measurementUUID,
      measurements: [measurementWord],
      task: {
        uuid: readingState.measurementUUID,
        extras: {
          type: MEASUREMENT_WCPM_TYPES.READING,
          total_mistakes: readingState.totalMistakes,
        },
      },
    });

    sendWCPM(store, boardId, readingState);
  },
  [setStartRecording]: (store, boardId, state, readingState) => {
    const task = {
      uuid: readingState.measurementUUID,
      extras: {
        type: 1,
        start: readingState.startRecording && new Date(readingState.startRecording),
      },
    };
    sendMeasurement(store, boardId, state, readingState, { task });
  },
  [setEndRecording]: (store, boardId, state, readingState) => {
    const task = {
      uuid: readingState.measurementUUID,
      extras: {
        type: 1,
        end: readingState.endRecording && new Date(readingState.endRecording),
        duration: readingState.startRecording && readingState.endRecording && ((readingState.endRecording - readingState.startRecording) / 1000),
      },
    };
    sendMeasurement(store, boardId, state, readingState, { task });
  },
  [setLastReadingWord]: (store, boardId, state, readingState) => {
    const task = {
      uuid: readingState.measurementUUID,
      extras: {
        type: MEASUREMENT_WCPM_TYPES.READING,
        end_word_location: readingState.lastReadingWord,
        total_words: readingState.firstReadingWord ? readingState.lastReadingWord - readingState.firstReadingWord + 1 : undefined,
        total_mistakes: readingState.totalMistakes,
      },
    };
    readingState.measurementUUID && sendMeasurement(store, boardId, state, readingState, { task });
    sendWCPM(store, boardId, readingState);
  },
  [setFirstReadingWord]: (store, boardId, state, readingState) => {
    sendMeasurement(store, boardId, state, readingState, {
      task: {
        uuid: readingState.measurementUUID,
        extras: {
          type: MEASUREMENT_WCPM_TYPES.READING,
          start_word_location: readingState.firstReadingWord,
          total_words: readingState.lastReadingWord ? readingState.lastReadingWord - readingState.firstReadingWord + 1 : undefined,
          total_mistakes: readingState.totalMistakes,
        },
      },
    });
    sendWCPM(store, boardId, readingState);
  },
};

export const handleReadingAction = (store, state, action) => {
  const currUser = currentUser(state);
  const boardId = action?.payload?.boardId;
  const readingState = boardId && state?.reading && getBoardStateById(boardId, state.reading);
  
  const isStudent = [ROLES.STUDENT.id, ROLES.CLINIC_ADMINISTRATOR.id].includes(currUser.role);

  readingState && isStudent && studentActions[action.type]?.(store, boardId, state, readingState, action?.payload?.value);
  readingState && currUser.role === ROLES.THERAPIST.id && therapistActions[action.type]?.(store, boardId, state, readingState, action?.payload?.value);
};
